import { render, staticRenderFns } from "./Dilets.vue?vue&type=template&id=a8d78bc0&scoped=true&"
import script from "./Dilets.vue?vue&type=script&lang=js&"
export * from "./Dilets.vue?vue&type=script&lang=js&"
import style0 from "./Dilets.vue?vue&type=style&index=0&id=a8d78bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d78bc0",
  null
  
)

export default component.exports